import React, { FC } from 'react'

import clsx from 'clsx'

import styles from './FullPageOnboarding.module.scss'
import { FullPageOnboardingProps } from './FullPageOnboarding.types'
import { MainScreen, RoleOverviewScreen } from './components'

export const FullPageOnboarding: FC<FullPageOnboardingProps> = props => {
  return (
    <div className={styles.fullPageOnboarding}>
      <div className={styles.pageViewport}>
        <div
          className={clsx(styles.page, {
            [styles.roleOverviewPage]: props.variant === 'role-overview'
          })}
        >
          {props.variant === 'role-overview' ? (
            <RoleOverviewScreen
              roles={props.roles}
              userName={props.userName}
              onComplete={props.onComplete}
            />
          ) : (
            <MainScreen
              onComplete={props.onComplete}
              onOpenFullTour={props.onOpenFullTour}
            />
          )}
        </div>
      </div>
    </div>
  )
}
